(() => {
  let scanQueued = false;
  let roomWarmQueued = false;
  const desktopRoom = window.matchMedia('(min-width: 1181px) and (hover: hover)');
  const roomImages = '#site-header #header-top .custom-mega-menu-room img[data-laboo-menu-thumbnail]';

  const sizeRoomImage = (image) => {
    if (!desktopRoom.matches) return;
    const width = Math.ceil(image.getBoundingClientRect().width);
    if (width > 0) image.sizes = width + 'px';
  };

  const isVisible = (image) => {
    if (!image.isConnected || image.closest('[hidden]')) return false;

    const menu = image.closest('.submenu, .mega-menu, .custom-mega-menu');
    const target = menu || image;
    const style = window.getComputedStyle(target);

    return style.display !== 'none' && style.visibility !== 'hidden' && target.getClientRects().length > 0;
  };

  const loadImage = (image, background = false) => {
    if (!image.dataset.src) return;

    if (image.hasAttribute('data-laboo-menu-thumbnail')) {
      sizeRoomImage(image);
      image.loading = 'eager';
      image.decoding = 'async';
      image.fetchPriority = background ? 'low' : 'auto';
    }

    if (image.dataset.srcset) image.srcset = image.dataset.srcset;
    const source = image.dataset.src;
    image.removeAttribute('data-srcset');
    image.removeAttribute('data-src');
    image.removeAttribute('data-laboo-deferred-image');
    image.src = source;
  };

  // Warm only the three desktop ROOM photos after the main page has loaded.
  // Mobile and data-saving connections keep the existing on-demand behaviour.
  const warmRoomImages = (background = false) => {
    if (!desktopRoom.matches) return;
    const connection = navigator.connection;
    if (background && connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType || ''))) return;
    document.querySelectorAll(roomImages).forEach((image) => loadImage(image, background));
  };

  const scheduleRoomWarm = () => {
    if (roomWarmQueued || !desktopRoom.matches) return;
    roomWarmQueued = true;
    const warm = () => {
      roomWarmQueued = false;
      warmRoomImages(true);
    };
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(warm, { timeout: 1500 });
    } else {
      window.setTimeout(warm, 500);
    }
  };

  const scan = () => {
    scanQueued = false;
    document.querySelectorAll('[data-laboo-deferred-image]').forEach((image) => {
      if (isVisible(image)) loadImage(image);
    });
  };

  const scheduleScan = () => {
    if (scanQueued) return;
    scanQueued = true;
    window.requestAnimationFrame(scan);
  };

  ['pointerover', 'focusin', 'click'].forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
      if (event.target instanceof Element && event.target.closest('#site-header #header-top')) {
        warmRoomImages();
      }
      scheduleScan();
    }, true);
  });

  if (document.readyState === 'complete') {
    scheduleRoomWarm();
  } else {
    window.addEventListener('load', scheduleRoomWarm, { once: true });
  }

  window.addEventListener('resize', () => {
    document.querySelectorAll(roomImages).forEach(sizeRoomImage);
    if (document.readyState === 'complete') scheduleRoomWarm();
  }, { passive: true });

  const observeHeader = () => {
    const header = document.querySelector('header, [data-header]');
    if (!header || !('MutationObserver' in window)) return;

    new MutationObserver(scheduleScan).observe(header, {
      attributes: true,
      subtree: true,
      attributeFilter: ['class', 'style', 'aria-expanded', 'aria-hidden', 'open']
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeHeader, { once: true });
  } else {
    observeHeader();
  }
})();
